import React from 'react';

const Card = ({ 
  title, 
  icon: Icon, 
  children, 
  className = "",
  headerActions = null 
}) => {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-2xl shadow-xl hover:shadow-2xl border border-gray-200 dark:border-gray-700 p-2 sm:p-4 mb-2 sm:mb-4 w-full max-w-full md:max-w-[900px] transition-all ${className}`}>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-2 sm:mb-4 gap-1 sm:gap-0">
        <div className="flex items-center">
          {Icon && <Icon className="w-6 h-6 sm:w-10 sm:h-10 text-blue-800 dark:text-blue-300 mr-0 sm:mr-4" />}
          <span className="text-lg sm:text-2xl font-extrabold text-blue-900 dark:text-blue-200">{title}</span>
        </div>
        {headerActions && (
          <div className="flex gap-2">
            {headerActions}
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default Card;
